module.exports = __webpack_public_path__ + "static/media/picto-engrave-white.427c0d09.svg";